import React, { Component } from 'react';
import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import renderTextField from '../../helpers/RenderTextFiledWithDiv';
import validationHelper from '../../helpers/ValidationHelper';
import autotecStyle from '../../components/Styles/style';

const validate = (values) => {
  const errors = validationHelper.validateRequired(['token'], values);
  if (values.token && values.token.length < 6) {
    errors.token = 'Token must be 6 characters in length';
  }
  return errors;
};

class VerifyUser extends Component {
  handleSave = (event) => {
    this.props.verifyUser(this.props.username, event.token);
  }

  resendVerificationCode = () => {
    this.props.resendVerificationCode(this.props.username);
  }

  render() {
    const { classes, handleSubmit } = this.props;
    return (
      <div>
        <h3>Enter verification code</h3>
        <Form onSubmit={handleSubmit(this.handleSave)}>
          <Field
            name="token"
            component={renderTextField}
            label="Verification Code"
            className={classes.textField}
            divClassName={classes.marginStyle}
          />
          <Button className={classes.buttonStyle} variant="raised" color="primary" type="submit">Verify</Button>
          <div>
            <Button className={classes.buttonStyle} style={{ marginTop: '2%', height: '15%' }} variant="raised" color="primary" type="button" onClick={r => this.resendVerificationCode()}>Resend verification code</Button>
          </div>
        </Form>
      </div>
    );
  }
}

VerifyUser.propTypes = {
    classes: PropTypes.shape().isRequired
};

export default withStyles(autotecStyle, { withTheme: true })(reduxForm({ form: 'VerifyUserForm', validate })(VerifyUser));


// WEBPACK FOOTER //
// ./src/components/User/VerifyUser.js